import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Group} from "../../../../types/interfaces";
import {ParentService} from "../../../../services/mygreencountry/parent.service";
import {MyGreenCountry} from "../../../../services/mygreencountry/my-greencountry";

@Component({
    selector: 'app-group-info',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.scss'],
})
export class InfoComponent implements OnInit, OnChanges {

    @Input() title: string = '';
    @Input() group: any = [];
    @Input() groupTitle: string = '';
    @Input() class: string = '';
    @Input() withMarginBtn: boolean = false;
    @Input() isSchedule: boolean = false;


    public activeTime: string = 'isCurrent';
    public showMoreInfo: boolean = false;

    activeGroupTime$ = this.GCService.getActiveGroupTime();

    constructor(private GCService: MyGreenCountry,) {

    }

    ngOnInit() {
        this.activeGroupTime$.subscribe({
            next: (activeTime) => {

                this.activeTime = activeTime;
                this.updateShowMoreInfo();
            }
        })

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['group']) {
            this.updateShowMoreInfo();
        }

        if (changes['activeTime']) {
            this.updateShowMoreInfo();
        }
    }

    private updateShowMoreInfo() {
        // this.showMoreInfo = this.activeTime === this.group.time;
    }

}
